module.exports = __webpack_public_path__ + "img/katarina_bedrooms_25.874d1ddf.jpg";